import {gql} from 'apollo-angular';
import {baseResponseGraphqlField} from '../../../base.graphql';

export const citizenServicesCategoryField = `
id
resultUniqueId
resultDescription

`;

export const GET_CITIZEN_SERVICES_RESULT = gql`
query CitizenGetServicesResults($serviceUniqueId:String){
    citizenGetServicesResults(serviceUniqueId:$serviceUniqueId){
    ${baseResponseGraphqlField}
    data {
      ${citizenServicesCategoryField}
    }
  }
}
`;
